module.exports = __webpack_public_path__ + "img/product-3a.c8e927e0.jpg";